import React from 'react';
import {FormikErrors, FormikTouched} from 'formik';
import {Insurance, PaymentMode} from '~/modules/booking/types';
import {BankIcon} from '~/assets/svgs';
import SelectInput from '~/components/SelectInput';
import Input from '~/components/Input';
import {EditBookingFormData} from '../schema';
import {EDIT_BOOKING_INSURANCE_OPTIONS} from '~/modules/frontdesk/constant';

type FinancialDetailsComponentProps = {
  values: EditBookingFormData;
  errors: FormikErrors<EditBookingFormData>;
  touched: FormikTouched<EditBookingFormData>;
  insuranceTypes: Insurance[];
  paymentMethods: PaymentMode[];
  renderSelfPayingValue: (value: string) => React.ReactNode;
  renderSelfPayingItem: (item: string) => React.ReactNode;
  renderInsuranceMenuItem: (item: Insurance) => React.ReactNode;
  renderInsuranceValue: (value: string) => React.ReactNode;
  renderPaymentMethodMenuItem: (item: PaymentMode) => React.ReactNode;
  renderPaymentMethodValue: (value: string) => React.ReactNode;
  handleSelfPayingChange: (value: string) => void;
  handlePaymentMethodChange: (value: string) => void;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  handleBlur: React.FocusEventHandler<HTMLInputElement>;
};

const FinancialDetailsComponent = (props: FinancialDetailsComponentProps) => {
  const {
    values,
    errors,
    touched,
    insuranceTypes,
    // paymentMethods,
    renderSelfPayingValue,
    renderSelfPayingItem,
    renderInsuranceMenuItem,
    renderInsuranceValue,
    // renderPaymentMethodMenuItem,
    // renderPaymentMethodValue,
    handleSelfPayingChange,
    handlePaymentMethodChange,
    handleBlur,
    handleChange,
  } = props;

  const isPaid = values.appointment.payment?.status === 'paid';

  return (
    <div className="flex flex-col p-6 bg-tertiary rounded-lg border-container flex-[5]">
      <div className="flex gap-2 items-center">
        <BankIcon />
        <h2 className="font-semibold text-lg leading-6 tracking-tight bg-gradient-clip">
          Financial details
        </h2>
      </div>
      <div className="flex flex-col gap-3 mt-3">
        <div className="font-normal text-sm leading-4 tracking-tight text-primary">
          Self paying
        </div>
        <SelectInput
          name="appointment.self_paying"
          value={values.appointment.self_paying ? 'Yes' : 'No'}
          items={EDIT_BOOKING_INSURANCE_OPTIONS}
          renderValue={renderSelfPayingValue}
          renderItem={renderSelfPayingItem}
          onBlur={handleBlur}
          onChange={handleSelfPayingChange}
          error={
            touched.appointment?.self_paying &&
            Boolean(errors.appointment?.self_paying)
          }
          disabled={isPaid}
        />
        {touched.appointment?.self_paying &&
          errors.appointment?.self_paying && (
            <p className="m-0 font-sans font-normal text-xs leading-relaxed tracking-wide text-danger ">
              {errors.appointment?.self_paying}
            </p>
          )}
      </div>

      {values.appointment.self_paying ? (
        <>
          {/* <div className="flex flex-col gap-3 mt-3">
            <div className="font-normal text-sm leading-4 tracking-tight text-primary">
              Payment Method
            </div>
            <SelectInput
              name="appointment.payment.payment_method"
              items={paymentMethods}
              placeholder="Select payment method"
              renderValue={renderPaymentMethodValue}
              renderItem={renderPaymentMethodMenuItem}
              value={values.appointment.payment?.payment_method || ''}
              onBlur={handleBlur}
              onChange={handlePaymentMethodChange}
              error={
                touched.appointment?.payment?.payment_method &&
                Boolean(errors.appointment?.payment?.payment_method)
              }
              disabled={isPaid}
            />
            {touched.appointment?.payment?.payment_method &&
              errors.appointment?.payment?.payment_method && (
                <p className="m-0 font-sans font-normal text-xs leading-relaxed tracking-wide text-danger ">
                  {errors.appointment?.payment?.payment_method}
                </p>
              )}
          </div> */}

          {values.appointment.payment && (
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-2 p-3 bg-white rounded-lg">
                <div className="flex flex-col gap-2">
                  {/* <div className="font-normal text-sm leading-4 tracking-tight text-primary">
                    Amount
                  </div> */}
                  {/* <Input
                    name="appointment.payment.amount"
                    placeholder="Enter amount"
                    value={String(values.appointment.payment.amount)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched.appointment?.payment?.amount}
                    error={
                      touched.appointment?.payment?.amount &&
                      Boolean(errors.appointment?.payment?.amount)
                    }
                    helperText={
                      touched.appointment?.payment?.amount &&
                      errors.appointment?.payment?.amount
                        ? errors.appointment?.payment?.amount
                        : ''
                    }
                    disabled={isPaid}
                  /> */}
                </div>
                <div className="flex flex-col gap-2 mt-2">
                  <div className="font-normal text-sm leading-4 tracking-tight text-primary">
                    Status
                  </div>
                  <div className="flex flex-col gap-2 p-3 bg-white rounded-lg border-container">
                    <span className="text-sm font-medium">
                      {values.appointment.payment.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="flex flex-col gap-3 mt-3">
            <div className="font-normal text-sm leading-4 tracking-tight text-primary">
              Insurance Details
            </div>
            <SelectInput
              name="appointment.insurance_claim.insurance_id"
              items={insuranceTypes}
              placeholder="Select insurer"
              renderValue={renderInsuranceValue}
              renderItem={renderInsuranceMenuItem}
              value={String(values.appointment.insurance_claim.insurance_id)}
              onBlur={handleBlur}
              onChange={handlePaymentMethodChange}
              error={
                touched.appointment?.insurance_claim?.insurance_id &&
                Boolean(errors?.appointment?.insurance_claim?.insurance_id)
              }
              disabled={isPaid}
            />
            {touched?.appointment?.insurance_claim?.insurance_id &&
              errors?.appointment?.insurance_claim?.insurance_id && (
                <p className="m-0 font-sans font-normal text-xs leading-relaxed tracking-wide text-danger ">
                  {errors.appointment?.insurance_claim?.insurance_id}
                </p>
              )}
            {touched?.appointment?.insurance_claim?.insurer_name &&
              errors?.appointment?.insurance_claim?.insurer_name && (
                <p className="m-0 font-sans font-normal text-xs leading-relaxed tracking-wide text-danger ">
                  {errors.appointment?.insurance_claim?.insurer_name}
                </p>
              )}

            <div className="flex flex-col gap-2 mt-2">
              <div className="font-normal text-sm leading-4 tracking-tight text-primary">
                Membership Number
              </div>
              <Input
                name="appointment.insurance_claim.membership_no"
                placeholder="Enter membership number"
                value={values.appointment.insurance_claim.membership_no || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                touched={touched.appointment?.insurance_claim?.membership_no}
                error={
                  touched.appointment?.insurance_claim?.membership_no &&
                  Boolean(errors.appointment?.insurance_claim?.membership_no)
                }
                helperText={
                  touched.appointment?.insurance_claim?.membership_no &&
                  errors.appointment?.insurance_claim?.membership_no
                    ? errors.appointment?.insurance_claim?.membership_no
                    : ''
                }
                disabled={isPaid}
              />
            </div>

            <div className="flex flex-col gap-2 mt-2">
              <div className="font-normal text-sm leading-4 tracking-tight text-primary">
                Pre-Authorization Code (Optional)
              </div>
              <Input
                name="appointment.insurance_claim.pre_authorisation_code"
                placeholder="Enter pre-authorization code"
                value={
                  values.appointment.insurance_claim.pre_authorisation_code ||
                  ''
                }
                onBlur={handleBlur}
                onChange={handleChange}
                touched={
                  touched.appointment?.insurance_claim?.pre_authorisation_code
                }
                error={
                  touched.appointment?.insurance_claim
                    ?.pre_authorisation_code &&
                  Boolean(
                    errors.appointment?.insurance_claim?.pre_authorisation_code
                  )
                }
                helperText={
                  touched.appointment?.insurance_claim
                    ?.pre_authorisation_code &&
                  errors.appointment?.insurance_claim?.pre_authorisation_code
                    ? errors.appointment?.insurance_claim
                        ?.pre_authorisation_code
                    : ''
                }
                disabled={isPaid}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FinancialDetailsComponent;
